<template>
    <customModal :containerxl="true" @closeModal="closeModal">
        <template #title>
            QTL Details
        </template>

        <template #body>
            <div class="modal-content-wrapper">
                <!-- ================= BASIC INFORMATION ================= -->
                <div class="section-block">
                    <h6 class="border-bottom py-1">
                        Basic Information
                    </h6>
                    <div class="row">
                        <!-- LEFT -->
                        <div class="col-md-6">
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block">
                                    <strong>CTQ ID</strong>
                                </div>
                                <div>
                                    {{ qtlDetails.ctqId }}
                                </div>
                            </div>
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block">
                                    <strong>CTQ Category</strong>
                                </div>
                                <div>
                                    {{ qtlDetails.ctqCategory }}
                                </div>
                            </div>

                            <div class="d-flex border-bottom py-1">
                                <div class="label-block">
                                    <strong>Responsible Owner</strong>
                                </div>
                                <div>
                                    {{ qtlDetails.responsibleOwner }}
                                </div>
                            </div>
                        </div>

                        <!-- RIGHT -->
                        <div class="col-md-6">
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block">
                                    <strong>Monitoring Frequency</strong>
                                </div>
                                <div>
                                    {{ qtlDetails.monitoringFrequency }}
                                </div>
                            </div>

                            <div class="d-flex border-bottom py-1">
                                <div class="label-block">
                                    <strong>Review Period</strong>
                                </div>
                                <div>
                                    {{ qtlDetails.reviewPeriod }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ================= CTQ FACTOR ================= -->

                <div class="section-block mt-2">

                    <h6 class="py-1">
                        CTQ Factor
                    </h6>

                    <div class="border rounded px-3 py-1 bg-light">
                        {{ qtlDetails.ctqFactor }}
                    </div>

                </div>

                <!-- ================= ESCALATION ACTION ================= -->

                <div class="section-block mt-2">
                    <h6 class="py-1"> EscalationAction </h6>
                    <div class="border rounded px-3 py-1 bg-light"> {{ qtlDetails.escalationAction }} </div>
                </div>

                <!-- ================= QTL DESCRIPTION ================= -->

                <div class="section-block mt-4">

                    <h6 class="py-1">
                        QTL Description
                    </h6>

                    <div class="border rounded px-3 py-1 bg-light">
                        {{ qtlDetails.qtlDescription }}
                    </div>

                </div>

                <!-- ================= QUALITY METRIC ================= -->

                <div class="section-block mt-4">

                    <div class="d-flex border-bottom py-1">
                        <div class="label-block">
                            <strong>Quality Metric</strong>
                        </div>

                        <div>
                            {{ qtlDetails.qualityMetric }}
                        </div>
                    </div>
                </div>

                <!-- ================= THRESHOLD CONFIGURATION ================= -->

                <!-- THRESHOLD CONFIGURATION -->
                <div class="section-block mt-4">

                    <h6 class="border-bottom py-1">
                        Threshold Configuration
                    </h6>

                    <div class="threshold-left">

                        <div class="d-flex border-bottom py-2">
                            <div class="label-block">
                                <strong>Threshold Type</strong>
                            </div>

                            <div>
                                {{ qtlDetails.thresholdType }}
                            </div>
                        </div>

                        <div class="d-flex py-2">
                            <div class="label-block">
                                <strong>Acceptable Limits</strong>
                            </div>

                            <div>
                                {{ qtlDetails.qtlAcceptableLimits }}
                            </div>
                        </div>
                    </div>

                </div>

                <!-- ================= THRESHOLD LEVELS ================= -->

                <div class="section-block mt-4">

                    <h6 class="py-1">
                        Threshold Levels
                    </h6>

                    <div class="table-responsive">

                        <table class="table table-bordered table-hover align-middle mb-0">

                            <thead class="table-light">

                                <tr>
                                    <th style="width:30%">Level</th>
                                    <th style="width:45%">Range</th>
                                    <th style="width:25%">Indicator</th>
                                </tr>

                            </thead>

                            <tbody>

                                <tr
                                    v-for="(threshold, index) in qtlDetails.thresholds"
                                    :key="index">

                                    <td>
                                      {{ threshold.label }}
                                    </td>
                                    <td>
                                      {{ threshold.min }} - {{ threshold.max }}
                                    </td>
                                    <td>

                                        <span
                                            class="badge"
                                            :class="{
                                                'badge-primary': threshold.color === 'Green',
                                                'badge-warning': threshold.color === 'Amber',
                                                'badge-danger': threshold.color === 'Red'
                                            }">

                                            {{ threshold.color }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </template>
    </customModal>
</template>

<script src="./QTLDetailsModal.js"></script>

<style scoped>

.modal-content-wrapper {
    max-height: 75vh;
    overflow-y: auto;
    padding-right: 4px;
}

.section-block {
    margin-bottom: 22px;
}

.section-block h6 {
    font-size: .9rem !important;
    font-weight: 600 !important;
    margin-bottom: 4px;
    color: #3d4b63;
}
.label-block {
    min-width: 180px;
}

.table {
    margin-bottom: 0;
}

.table td,
.table th {
    vertical-align: middle;
}

.table th {
    font-weight: 600;
}

.threshold-left {
    margin-top: -8px;
}

</style>